/**
 * @file SubmitSuccess
 * @author zhaomiaoyuan
 */
import React from 'react';
import {useHistory} from 'react-router-dom';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import Button from 'antd/lib/button';
import successIcon from '../../asset/img/appeal/submit_succeed.png';
import {recordProxy} from '../../util';

const SubmitSuccess = (props) => {
    const {listUrl} = props;
    const history = useHistory();
    function goHome() {
        recordProxy('url-home', 'click', '返回首页');
        history.push('/home');
    }
    function goList() {
        recordProxy('url-my_feedback', 'click', '查看记录');
        history.push(listUrl);
    }
    return (
        <div className="submit-success" style={{marginTop: '80px'}}>
            <img width={152} src={successIcon} />
            <p className="title">提交成功!</p>
            <p className="sub-title">感谢您的反馈，我们会尽快完成处理</p>
            <Button
                className="btn"
                onClick={goHome}>返回首页</Button>
            <Button
                className="btn"
                onClick={goList}>查看记录</Button>
        </div>
    );
};

SubmitSuccess.propTypes = {
    listUrl: PropTypes.string
};

export default withRouter(SubmitSuccess);
